import Vue from 'vue'
import App from './App.vue'
import routerDefault from './router'
import routerPublic from './routerPublic'
import store from './store'
import VueLocalStorage from 'vue-localstorage'
import Axios from 'axios'
import VeeValidate from 'vee-validate'
import VueSweetalert2 from 'vue-sweetalert2'
import BootstrapVue from 'bootstrap-vue'
import Loading from 'vue-loading-overlay'
import 'vue-loading-overlay/dist/vue-loading.css'
import VueCurrencyInput from 'vue-currency-input'
import VueHead from 'vue-head'
import moment from 'moment'
import VueCookies from 'vue-cookies'
import SecureRandom from 'secure-random-string'
import globals from './globals'
import { STATE_LIST, TIME_ZONE_LIST } from './commonVariables'
import PageViewService from './services/PageViewService'
import Vue2Filters from 'vue2-filters'
import marked from 'marked'
import VueMobileDetection from 'vue-mobile-detection'
import Skeleton from 'vue-loading-skeleton'

window.Vue = Vue

Vue.use(VueSweetalert2)
Vue.use(VueLocalStorage)
Vue.use(VeeValidate, {
  classes: true,
  classNames: {
    valid: 'is-valid',
    invalid: 'is-invalid'
  }
})
Vue.use(BootstrapVue)
Vue.use(Loading)
Vue.use(VueCookies)
Vue.use(VueCurrencyInput, {
  globalOptions: {
    currency: 'USD',
    autoDecimalMode: false,
    valueAsInteger: true,
    allowNegative: false,
    locale: 'en'
  }
})
Vue.use(VueHead)
Vue.use(Vue2Filters)
Vue.use(VueMobileDetection)
Vue.use(Skeleton)

Vue.config.productionTip = false

/** AXIOS **/
const axios = Axios.create({
  baseURL: process.env.VUE_APP_BACKEND_API
})

axios.interceptors.request.use(function (config) {
  var hostName = window.location.host.split('.')
  var subdomain = (hostName.length === 3) ? hostName[0] : null

  config.headers.common['Subdomain'] = subdomain
  config.headers.common['Authorization'] = Vue.localStorage.get('apikey')
  config.headers.common['X-Timezone-Offset'] = moment.tz.guess()

  return config
})

axios.interceptors.response.use((response) => {
  return response
}, function (error) {
  var responseStatus = error.response && error.response.status

  if (responseStatus === 403) {
    app.$router.push({
      name: 'home',
      params: { showForbiddenMessage: true }
    })
  }

  return Promise.reject(error)
})

Vue.prototype.$http = axios
/**  AXIOS **/

Vue.prototype.$marked = marked
Vue.prototype.moment = moment

const host = window.location.host
const domainStructure = host.split('.')
const domainLength = 3 // route1.example.com => domain length = 3
const getReferrer = (doc, loc, from) => {
  const internalReferrer = loc.origin + from.fullPath
  const localReferrer = Vue.localStorage.get('referrer')
  const docReferrer = doc.referrer

  if (localReferrer && docReferrer && docReferrer === localReferrer) {
    return internalReferrer
  } else {
    if (docReferrer) {
      Vue.localStorage.set('referrer', docReferrer)
      return docReferrer
    } else {
      Vue.localStorage.set('referrer', internalReferrer)
      return internalReferrer
    }
  }
}

// set default config for cookies
Vue.$cookies.config('7d')

// Set default cookie for anonymous id
if (!Vue.$cookies.isKey('anonymousId')) {
  Vue.$cookies.set('anonymousId', SecureRandom())
}

const router = () => {
  let routes

  if (domainStructure.length === (domainLength - 1) || domainStructure[0] === 'www' ||
      domainStructure[0].match(/localhost/) || domainStructure[0].startsWith('staging')) {
    routerDefault.beforeEach((to, from, next) => {
      if (to.meta.requiresAuth) {
        if (Vue.localStorage.get('apikey')) {
          if (to.meta.limitedAccess) {
            var userType = Vue.localStorage.get('user_type')
            var authorizedRoles = to.meta.authorizedRoles

            // Check user roles to continue
            if (authorizedRoles.includes(userType)) {
              next()
            } else {
              next({
                path: '/',
                query: { redirect: to.fullPath }
              })
            }
          } else {
            next()
          }
        } else {
          next({
            path: '/authenticate',
            query: { redirect: to.fullPath }
          })
        }
      } else {
        next()
      }
    })

    routes = routerDefault
  } else {
    routes = routerPublic
  }

  routes.afterEach((to, from) => {
    PageViewService.createPageView({
      name: to.name,
      path: to.fullPath,
      referrer: getReferrer(document, location, from),
      search: location.search,
      title: to.name, // Using route name until we have a 'title'
      url: location.origin + to.fullPath,
      user_id: Vue.localStorage.get('user_reference'),
      anonymous_id: Vue.$cookies.get('anonymousId'),
      model_type: to.meta.modelType,
      model_id: to.params.id,
      from_ip: null
    })
  })

  return routes
}

Vue.prototype.$timeZoneList = TIME_ZONE_LIST
Vue.prototype.$stateList = STATE_LIST

// Global RTL flag
Vue.mixin({
  data: globals
})

const app = new Vue({
  render: h => h(App),
  store,
  computed: {
    getUserType () {
      return this.$store.getters.getUserType
    }
  },
  data: {
    logged: !!Vue.localStorage.get('apikey'),
    user_type: Vue.localStorage.get('user_type') ? Vue.localStorage.get('user_type') : null
  },
  methods: {
    logout () {
      this.$localStorage.remove('apikey')
      this.$localStorage.remove('user_type')
      this.$localStorage.remove('user_reference')
      this.$localStorage.remove('user_first_name')
      this.$localStorage.remove('user_last_name')
      this.$localStorage.remove('user_email')

      // Update user type after connect stripe account
      this.$store.commit('updateUserType', null)

      app.$root.logged = false
      app.$router.push({ name: 'logout',
        params: {
          logoutSuccessfully: true
        }
      })
    }
  },
  router: router(),
  components: { App }
}).$mount('#app')
